import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent implements OnInit {

  public errorMsg: string;
  public successMsg: string;
  public email = '';

  constructor(private router: Router, private api: ApiService, private translate: TranslateService) { }

  ngOnInit() {
  }

  sendForgotPassword() {
    if (this.email && this.email !== '' && this.validateEmail(this.email)) {
      this.api.postData('public/request-password-reset', this.email).subscribe(result => {
        // console.log('result', result);
        this.errorMsg = null;
        this.successMsg = this.translate.instant('_FORGOT_PASSWORD.SUCCESS_MSG');
        this.email = '';
      }, error => {
        console.log('error', error);
        this.errorMsg = this.translate.instant('_FORGOT_PASSWORD.DEFAULT_ERROR_MSG');
        this.successMsg = null;
      });
    } else {
      this.errorMsg = this.translate.instant('_FORGOT_PASSWORD.EMAIL_ERROR_MSG');
      this.successMsg = null;
    }
  }

  validateEmail(email) {
    const re = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);
    return re.test(String(email).toLowerCase());
  }

  removeMessages() {
    this.errorMsg = null;
    this.successMsg = null;
  }

  goToLogin() {
    this.router.navigate(['login'], {}).then();
  }

}
